export const isNull = (input: any): boolean => {
  return input === null
}
